/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgTextBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.60001 5.4V4.8016C3.5998 4.56509 3.6462 4.33085 3.73656 4.11228C3.82693 3.89371 3.95948 3.69509 4.12665 3.52777C4.29381 3.36046 4.49232 3.22773 4.71081 3.13717C4.9293 3.04661 5.16349 3 5.40001 3H18.6C18.8365 3 19.0707 3.04661 19.2892 3.13717C19.5077 3.22773 19.7062 3.36046 19.8734 3.52777C20.0405 3.69509 20.1731 3.89371 20.2634 4.11228C20.3538 4.33085 20.4002 4.56509 20.4 4.8016V5.4016M11.9996 3V21M8.39896 20.9999H15.599"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgText = wrapIcon(SvgTextBase);
export default SvgText;
